export var TITLE = 'OpenAI';
export var TEXT_MULTIPLE = 0.75;
export var SPACE_MULTIPLE = 0.1;
export var COLOR_PRIMARY = '#000';
export var COLOR_GPT_3 = '#19C37D';
export var COLOR_GPT_4 = '#AB68FF';
export var COLOR_O_1 = '#F9C322';